module.exports = __webpack_public_path__ + "img/tooltip-blue.906d66d6.svg";